// extracted by mini-css-extract-plugin
export default {"page":"I5l85","inner":"W5ioz","main":"WW4Cg","actions":"QNrex"};